import { render, staticRenderFns } from "./Dentoholic.vue?vue&type=template&id=1b3bb4a2&scoped=true&"
import script from "./Dentoholic.vue?vue&type=script&lang=js&"
export * from "./Dentoholic.vue?vue&type=script&lang=js&"
import style0 from "./Dentoholic.vue?vue&type=style&index=0&id=1b3bb4a2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3bb4a2",
  null
  
)

export default component.exports